var MailListContextMenuSource;
(function (MailListContextMenuSource) {
    MailListContextMenuSource[MailListContextMenuSource["MailListItem"] = 0] = "MailListItem";
    MailListContextMenuSource[MailListContextMenuSource["MailListItemPart"] = 1] = "MailListItemPart";
})(MailListContextMenuSource || (MailListContextMenuSource = {}));
export default MailListContextMenuSource;
//# sourceMappingURL=MailListContextMenuSource.js.map